export default "__VITE_ASSET__DFDsboDz__";